import VFocus from '@/directives/VFocus'
import VIntersection from '@/directives/VIntersection'
import VClickOutsideCapturing from '@/directives/VClickOutsideCapturing'

export default {
    focus: VFocus,
    intersection: VIntersection,
    'click-outside-capturing': VClickOutsideCapturing
}
